import React from 'react';
import { WppTypography, WppInput, WppInlineMessage } from 'buildingBlocks';
import { BULK_CREATE_HELP_CENTER_LINK } from 'containers/App/constants';
import { InputChangeEventDetail, WppInputCustomEvent } from 'utils/types';
import { DspToPixel, PixelCategories } from 'containers/StrategyWizard/components/PixelPicker/types';
import CategorySwitcher from 'containers/StrategyWizard/components/PixelPicker/PixelPickerModal/CategorySwitcher';
import { bulkCreatePixelPickerStyles } from 'containers/BulkCreateStrategyWizard/steps/GoalSelection/styles';
import { isBulkCreateMode } from 'containers/StrategyWizard/utils';
import { getTotalMatchingPixelCount } from '../utils';
import { PIXEL_PICKER_STYLES } from '../styles';

const { headerMessage } = PIXEL_PICKER_STYLES;
const { subHeaderMessage } = bulkCreatePixelPickerStyles;

type PixelModalHeaderSectionProps = {
  searchStr: string
  setSearchStr: (value: string) => void
  pixelCategory: PixelCategories
  setPixelCategory: (value: PixelCategories) => void
  pixels: DspToPixel
  selectedModalPixels: DspToPixel
};

const PixelModalHeaderSection = ({
  searchStr,
  setSearchStr,
  pixelCategory,
  setPixelCategory,
  pixels,
  selectedModalPixels,
}: PixelModalHeaderSectionProps) => {
  const isBulkCreate = isBulkCreateMode(location?.pathname ?? '');

  return (
    <>
      <div slot="body">
        <WppTypography
          className="wppTypographySegmentColor"
          type="s-body"
          tag="p"
          style={!isBulkCreate ? headerMessage : null}
        >
          Select and assign weights to the conversion pixels which contribute towards the strategy goal.
        </WppTypography>
        {isBulkCreate && (
          <div style={subHeaderMessage}>
            <WppInlineMessage
              type="information"
              size="l"
              titleText="Unable to select certain pixels?"
              message="Only pixels present in all objects can be selected for bulk creation."
              showTooltipFrom={1000}
              actionBtnText="Learn more"
              onWppClickActionBtn={() => window.open(BULK_CREATE_HELP_CENTER_LINK, '_blank')}
            />
          </div>
        )}
        <WppInput
          id="pixel-picker-search"
          placeholder="Search by pixel name or ID"
          value={searchStr}
          type="search"
          size="s"
          onWppChange={(event: WppInputCustomEvent<InputChangeEventDetail>) => setSearchStr(event.detail.value)}
        />
        <CategorySwitcher
          pixelCategory={pixelCategory}
          setPixelCategory={setPixelCategory}
          allCount={getTotalMatchingPixelCount(pixels, searchStr)}
          selectedCount={getTotalMatchingPixelCount(selectedModalPixels, searchStr)}
        />
      </div>
    </>
  );
};

export default PixelModalHeaderSection;
